import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getBalikovnaFetchSuccess, getBalikovnaFetchFailure } from './reducer';
import { BalikovnaResType } from 'src/types/balikovna';

const getBalikovnaFetchRequest = async () => {
    const res = await api('get', `api/secure/shippers/balikovna/address`);
    return res.data;
};

function* getBalikovnaFetch() {
    try {
        const response: BalikovnaResType = yield call((): any => getBalikovnaFetchRequest());

        yield put(getBalikovnaFetchSuccess(response));
    } catch (error) {
        yield put(getBalikovnaFetchFailure({ error }));
    }
}

export function* getBalikovnaFetchWatch() {
    yield takeEvery('balikovna/getBalikovnaFetch', getBalikovnaFetch);
}
